import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { AnalyticsController } from 'analytics/analytics-controller';
import { GTM_CLICK_ADDRESS_PAGE_VIRTUAL_TOUR_BUTTON } from 'constants/events';

export interface VirtualTourButtonData {
  /** Pre-formatted button label */
  label: string;
  /** Pre-wired click handler with analytics */
  onClick: () => void;
}

/**
 * useVirtualTourButton Hook
 * 
 * Handles i18n and analytics for the VirtualTourButton domain component.
 * 
 * Pattern: Hook handles i18n + analytics → Domain component receives strings + handlers
 * 
 * @param isModal - Whether this is being rendered in a modal context
 * @returns Formatted button data
 */
export function useVirtualTourButton(isModal: boolean = false): VirtualTourButtonData {
  const { t } = useTranslation(Namespaces.COMMON);

  const label = t(LOCALE_COMMON_PATHS.LISTING_CONTENT_VIRTUAL_TOUR_BUTTON_LABEL, { 
    defaultValue: 'Virtual Tour', 
  });

  const onClick = () => {
    if (!isModal) {
      AnalyticsController.trackEvent(GTM_CLICK_ADDRESS_PAGE_VIRTUAL_TOUR_BUTTON);
    }
  };

  return {
    label,
    onClick,
  };
}
